export default __webpack_public_path__ + "6132d83a69d1c439e86014e833f6fe8a.svg";